module.exports = __webpack_public_path__ + "static/img/last-sec-bg.65dc553.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/last-sec-bg.jpg
// module id = Ba/8
// module chunks = 1